import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom"; 
import BlogModal from "../BlogModal";
import axios from "axios";
import "./style.css";

const ManageBlog = () => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [updatedBlogContent, setUpdatedBlogContent] = useState(null);
  const [updatedBlogHeader, setUpdatedBlogHeader] = useState(null);
  const [updatedBlogDate, setUpdatedBlogDate] = useState(null);
  const [updatedBlogImage, setUpdatedBlogImage] = useState(null);
  const [updatedBlogCategory, setUpdatedBlogCategory] = useState(null);
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [deletedBlogs, setDeletedBlogs] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [blogData, setBlogData] = useState({
    blogHeader: "",
    blogDate: "",
    blogContent: "",
    blogImage: null,
    blogCategory: "",
  });

  let apiEndpoint = "https://jacobjose.azurewebsites.net/api/dashboard/blogs";
  const history = useHistory();

  useEffect(() => {
    axios.get(apiEndpoint)
      .then((response) => {
        setBlogs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
      });
  }, []);

  const fetchBlogDetails = (blogId) => {
    if (blogId) {
      axios.get(`${apiEndpoint}/blogs/${blogId}`)
        .then((response) => {
          const { blogHeader, blogDate, blogContent, blogImage, blogCategory } = response.data;
          setBlogData({ blogHeader, blogDate, blogContent, blogImage, blogCategory });
        })
        .catch((error) => {
          console.error("Error fetching blog details:", error);
        });
    }
  };

  const handleBlogSelection = (blogId) => {
    setSelectedBlogId(blogId);
    setModalVisibility(true);
    fetchBlogDetails(blogId);
  };

  const handleUpdate = (updatedContent, updatedHeader, updatedDate, updatedImage, updatedCategory) => {
    setUpdatedBlogContent(updatedContent);
    setUpdatedBlogHeader(updatedHeader);
    setUpdatedBlogDate(updatedDate);
    setUpdatedBlogImage(updatedImage);
    setUpdatedBlogCategory(updatedCategory);

    if (selectedBlogId) {
      axios.put(`${apiEndpoint}/blogs/${selectedBlogId}`, {
        blogHeader: updatedHeader,
        blogDate: updatedDate,
        blogContent: updatedContent,
        blogImage: updatedImage,
        blogCategory: updatedCategory,
      })
        .then((response) => {
          console.log("Blog updated successfully:", response.data);
          history.push("/blogs"); 
        })
        .catch((error) => {
          console.error("Error updating blog:", error);
        });
    }
  };

  const handleDelete = () => {
    apiEndpoint = "https://jacobjose.azurewebsites.net/api/dashboard/deleteblogs";
    if (selectedBlogId) {
      axios.delete(`${apiEndpoint}/blogs/${selectedBlogId}`)
        .then((response) => {
          console.log("Blog deleted successfully:", response.data);
          const deletedBlog = {
            header: updatedBlogHeader,
            date: updatedBlogDate,
            content: updatedBlogContent,
            image: updatedBlogImage,
            category: updatedBlogCategory,
          };
          setDeletedBlogs([...deletedBlogs, deletedBlog]);
          setUpdatedBlogContent(null);
          setUpdatedBlogHeader(null);
          setUpdatedBlogDate(null);
          setUpdatedBlogImage(null);
          setUpdatedBlogCategory(null);
          history.push("/blogs");
        })
        .catch((error) => {
          console.error("Error deleting blog:", error);
        });
    }
  };

  return (
    <div className="manage-blog">
      <h2>Manage Blogs</h2>
      <ul className="vertical-menu">
        {blogs.map((blog) => (
          <li key={blog.id}>
            <button onClick={() => handleBlogSelection(blog.id)}>
              {blog.blogHeader}
            </button>
          </li>
        ))}
      </ul>
      {isModalVisible && (
        <BlogModal
          blogId={selectedBlogId}
          onClose={() => setModalVisibility(false)}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
          initialHeader={blogData.blogHeader}
          initialContent={blogData.blogContent}
          initialDate={blogData.blogDate}
          initialImage={blogData.blogImage}
          initialCategory={blogData.blogCategory}
        />
      )}
      {updatedBlogContent && (
        <div className="updated-blog-content">
          <h3>Updated Header: {updatedBlogHeader}</h3>
          <p>Updated Date: {updatedBlogDate}</p>
          <p>Updated Category: {updatedBlogCategory}</p>
          <div>{updatedBlogContent}</div>
          {updatedBlogImage && (
            <img src={updatedBlogImage} alt="Blog Image" />
          )}
        </div>
      )}
    </div>
  );
};

export default ManageBlog;
